<template>
    <Layout :title="$t('payment.plans.title')">
        <Spinner v-if="loading" class="spinner--transparent" />
        <StaticContent>
            <div v-html="static.data"></div>
            <LimitsList
                v-if="limitsByCurrency[userCurrency].length"
                :limits="limitsByCurrency[userCurrency]"
                large
            />
        </StaticContent>
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import StaticContent from '@speechki-frontend/shared/ui/StaticContent';
import { LimitsList } from '@speechki-frontend/core/payment/components';

import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'PlansPage',
    components: {
        Layout,
        StaticContent,
        LimitsList
    },
    data() {
        return {
            static: '',
            loading: false
        };
    },
    computed: {
        ...mapGetters(['limitsByCurrency', 'userCurrency'])
    },
    async created() {
        this.loading = true;
        const promises = [this.fetchInfo()];

        if (!this.$store.state.payment.limits.length) {
            promises.push(this.fetchLimits());
        }
        await Promise.all(promises);
        this.loading = false;
    },
    methods: {
        ...mapActions(['fetchLimits']),
        async fetchInfo() {
            const modifier = this.$i18n.locale === 'eng' ? '-en' : '';
            try {
                this.static = await this.$http.get(`/api/v1/information/docs-plans${modifier}/`);
            } catch (e) {
                console.log(e);
            }
        }
    }
};
</script>
